import React, {useEffect, useState} from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import FloatingSubjects from './floating-subject-selection';
import SubjectLoadthrough from './loadthrough';
import addPropertiesAsSuperToTracker from '../../../utils/add-super-props';
import { useSelector } from 'react-redux'
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { TrackUserActionAnalytics } from '../../../services/loggedout-api';

const SubjectSelection = ({isNextStep, goToNextHandler}) => {

  const { childScreenName, selectedGrade, skipPOQ } = useSelector(state => {
    return {
      childScreenName: state.childScreenName,
      selectedGrade: state.selectedGrade,
      skipPOQ: state.skipPOQ,
    }
  });

  const [animate, setAnimate] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [header, setHeader] = useState(`What would you like ${childScreenName} to start with?`);
  const [headerTransition, setHeaderTransition] = useState(undefined);
  const [headerExit, setHeaderExit] = useState(false);

  const { setValue } = useExtendedLocalStorage('splashverse-onboarding', '');

  const subjectSelectedHandler = async (subject) => {
    setSelectedSubject(subject);
    doHeaderTransition();
    try {
      setValue('selectedSubject', subject);
      setHeader('Great');
      TrackUserActionAnalytics({
        user_action: 'subject_select',
        action_info: {
          grade_code: selectedGrade,
          subject_code: subject
        }
      }, true);
      setTimeout(() => {
        doHeaderTransition(true);
      }, 2000);
    } catch(e) {
      console.log(e);
    }
  }

  const doHeaderTransition = (exit) => {
    setHeaderTransition(false);
    if (exit) {
      setHeaderExit(true);
    }
    setTimeout(() => {
      setHeaderTransition(true);
    }, 700);
  }

  useEffect(() => {
    addPropertiesAsSuperToTracker({
      'Grade': selectedGrade
    });
    trackAnalyticsEvent('Subject Selection Screen Viewed',{});
    setTimeout(() => {
      setAnimate(true);
    }, 100);
  }, []);

  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
          <SS.StepHeader showTransition={headerTransition} exit={headerExit}>
            {header}
          </SS.StepHeader>
          {selectedSubject ?
            <SubjectLoadthrough
              selectedSubject={selectedSubject}
              goToNextHandler={goToNextHandler}
              skipPOQ={skipPOQ}
              isPreKindergarten={selectedGrade === 'pk'}
            /> : (
              <>
                <FloatingSubjects
                  subjectSelectedHandler={subjectSelectedHandler}
                  setHeader={setHeader}
                  doHeaderTransition={doHeaderTransition}
                />
                <SS.Footer>
                  You can always switch between the two later
                </SS.Footer>
              </>
            )
          }
        </SS.OnboardingStepWrapper>
      )}
    </Transition>
  )
}

export default SubjectSelection;